/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PatchedPortfolioDetailRequest,
  PortfolioDetail,
  PortfolioDetailRequest,
  PortfolioKpi,
  PortfolioPendingData,
  PortfoliosKpisRetrieveParams,
  PortfoliosListParams,
  PortfoliosPendingDataRetrieveParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type portfoliosListResponse200 = {
  data: PortfolioDetail[]
  status: 200
}

export type portfoliosListResponseSuccess = (portfoliosListResponse200) & {
  headers: Headers;
};
;

export type portfoliosListResponse = (portfoliosListResponseSuccess)

export const getPortfoliosListUrl = (params?: PortfoliosListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/portfolios/?${stringifiedParams}` : `/api/v1/portfolios/`
}

export const portfoliosList = async (params?: PortfoliosListParams, options?: RequestInit): Promise<portfoliosListResponse> => {

  return customFetch<portfoliosListResponse>(getPortfoliosListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type portfoliosCreateResponse201 = {
  data: PortfolioDetail
  status: 201
}

export type portfoliosCreateResponseSuccess = (portfoliosCreateResponse201) & {
  headers: Headers;
};
;

export type portfoliosCreateResponse = (portfoliosCreateResponseSuccess)

export const getPortfoliosCreateUrl = () => {




  return `/api/v1/portfolios/`
}

export const portfoliosCreate = async (portfolioDetailRequest: PortfolioDetailRequest, options?: RequestInit): Promise<portfoliosCreateResponse> => {

  return customFetch<portfoliosCreateResponse>(getPortfoliosCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(portfolioDetailRequest)
  }
);}


export type portfoliosRetrieveResponse200 = {
  data: PortfolioDetail
  status: 200
}

export type portfoliosRetrieveResponseSuccess = (portfoliosRetrieveResponse200) & {
  headers: Headers;
};
;

export type portfoliosRetrieveResponse = (portfoliosRetrieveResponseSuccess)

export const getPortfoliosRetrieveUrl = (id: string,) => {




  return `/api/v1/portfolios/${id}/`
}

export const portfoliosRetrieve = async (id: string, options?: RequestInit): Promise<portfoliosRetrieveResponse> => {

  return customFetch<portfoliosRetrieveResponse>(getPortfoliosRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type portfoliosUpdateResponse200 = {
  data: PortfolioDetail
  status: 200
}

export type portfoliosUpdateResponseSuccess = (portfoliosUpdateResponse200) & {
  headers: Headers;
};
;

export type portfoliosUpdateResponse = (portfoliosUpdateResponseSuccess)

export const getPortfoliosUpdateUrl = (id: string,) => {




  return `/api/v1/portfolios/${id}/`
}

export const portfoliosUpdate = async (id: string,
    portfolioDetailRequest: PortfolioDetailRequest, options?: RequestInit): Promise<portfoliosUpdateResponse> => {

  return customFetch<portfoliosUpdateResponse>(getPortfoliosUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(portfolioDetailRequest)
  }
);}


export type portfoliosPartialUpdateResponse200 = {
  data: PortfolioDetail
  status: 200
}

export type portfoliosPartialUpdateResponseSuccess = (portfoliosPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type portfoliosPartialUpdateResponse = (portfoliosPartialUpdateResponseSuccess)

export const getPortfoliosPartialUpdateUrl = (id: string,) => {




  return `/api/v1/portfolios/${id}/`
}

export const portfoliosPartialUpdate = async (id: string,
    patchedPortfolioDetailRequest?: PatchedPortfolioDetailRequest, options?: RequestInit): Promise<portfoliosPartialUpdateResponse> => {

  return customFetch<portfoliosPartialUpdateResponse>(getPortfoliosPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedPortfolioDetailRequest)
  }
);}


export type portfoliosDestroyResponse204 = {
  data: void
  status: 204
}

export type portfoliosDestroyResponseSuccess = (portfoliosDestroyResponse204) & {
  headers: Headers;
};
;

export type portfoliosDestroyResponse = (portfoliosDestroyResponseSuccess)

export const getPortfoliosDestroyUrl = (id: string,) => {




  return `/api/v1/portfolios/${id}/`
}

export const portfoliosDestroy = async (id: string, options?: RequestInit): Promise<portfoliosDestroyResponse> => {

  return customFetch<portfoliosDestroyResponse>(getPortfoliosDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type portfoliosKpisRetrieveResponse200 = {
  data: PortfolioKpi
  status: 200
}

export type portfoliosKpisRetrieveResponseSuccess = (portfoliosKpisRetrieveResponse200) & {
  headers: Headers;
};
;

export type portfoliosKpisRetrieveResponse = (portfoliosKpisRetrieveResponseSuccess)

export const getPortfoliosKpisRetrieveUrl = (params?: PortfoliosKpisRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","property","region","service_provider"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/portfolios/kpis/?${stringifiedParams}` : `/api/v1/portfolios/kpis/`
}

export const portfoliosKpisRetrieve = async (params?: PortfoliosKpisRetrieveParams, options?: RequestInit): Promise<portfoliosKpisRetrieveResponse> => {

  return customFetch<portfoliosKpisRetrieveResponse>(getPortfoliosKpisRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type portfoliosPendingDataRetrieveResponse200 = {
  data: PortfolioPendingData
  status: 200
}

export type portfoliosPendingDataRetrieveResponseSuccess = (portfoliosPendingDataRetrieveResponse200) & {
  headers: Headers;
};
;

export type portfoliosPendingDataRetrieveResponse = (portfoliosPendingDataRetrieveResponseSuccess)

export const getPortfoliosPendingDataRetrieveUrl = (params?: PortfoliosPendingDataRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolios"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/portfolios/pending-data/?${stringifiedParams}` : `/api/v1/portfolios/pending-data/`
}

export const portfoliosPendingDataRetrieve = async (params?: PortfoliosPendingDataRetrieveParams, options?: RequestInit): Promise<portfoliosPendingDataRetrieveResponse> => {

  return customFetch<portfoliosPendingDataRetrieveResponse>(getPortfoliosPendingDataRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


